import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

/**
 * Route component that only allows access to authenticated users
 * Redirects to login page if not authenticated
 * Redirects to verify-email if email is not verified
 */
const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isEmailVerified, user, loading } = useContext(AuthContext);
  
  // Show loading indicator while checking auth
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: window.location.pathname }} />;
  }
  
  // Redirect to email verification page if email is not verified
  if (!isEmailVerified) {
    return <Navigate to="/verify-email" state={{ email: user?.email }} />;
  }
  
  // Return the protected content
  return children;
};

export default PrivateRoute;